import { App } from 'vue';
import { buildMande } from '@/api/global';
import { reportVideoPlayEvent } from '@/composables/user-activity-monitor';
import { mediaMandeSymbol, onVideoPlaySymbol, mediaLoggerSymbol } from '@tmi/media';
import { createDefaultLogger } from '@/types/console-logger';

const contentApi = buildMande( `${ import.meta.env.VITE_CONTENT_BASE_URI }${ import.meta.env.VITE_CONTENT_REL_PATH }` );
const logger = createDefaultLogger();

const MediaPlugin = {
    install( app: App< Element > ) {
        app.provide( mediaMandeSymbol, contentApi );
        app.provide( onVideoPlaySymbol, reportVideoPlayEvent );
        app.provide( mediaLoggerSymbol, logger );
    }
};

export default MediaPlugin;
